'use client';

import { isEmpty } from 'lodash';
import { ComponentProps, FC } from 'react';
import useSWR, { Fetcher } from 'swr';

import { fetchRecommendedVehicles } from 'src/data/ProductApi/ProductApiListVehicles';
import { CarouselSection } from 'src/general/components/Carousel/CarouselSection';
import { PlpMarketingTile } from 'src/plp/components/PlpMarketingTile/PlpMarketingTile';
import { ProductListDataPayload, ProductListDataRow } from 'src/types/CataloguePage.types';

import { pushCarmaRecommendationEvent } from 'src/general/helpers/pushCarmaRecommendationEvent';
import { FlexibleSection } from '../flexibleContent.type';
import { getSectionClasses } from '../getSectionClasses.helper';
import { generateTiles } from './generateTiles';

interface Props extends FlexibleSection {
  sectionData: {
    title?: string;
    marketingItems?: ComponentProps<typeof PlpMarketingTile>[];
  };
}

const fetcher: Fetcher<ProductListDataPayload, { id: string }> = () => fetchRecommendedVehicles();

export const RecommendedCarsCarousel: FC<Props> = ({ sectionData, sectionBackground }) => {
  const { data, isLoading } = useSWR({ id: 'fetchRecommendedVehicles' }, fetcher, {
    refreshInterval: 60000,
  });

  const onCardClick = (product: ProductListDataRow) => {
    // Send an event to the miniCDP to capture the recommendation id and the SKU displayed
    pushCarmaRecommendationEvent('recommended', data?.results, data?.recommendation_id)(product.sku);
  };

  const tiles = generateTiles(isLoading, data?.results, sectionData.marketingItems, onCardClick);

  if (tiles.length <= 4) return null;

  return (
    <section className={getSectionClasses(sectionBackground)}>
      {!isEmpty(sectionData.title) && (
        <header className="mb-4">
          <h2 className="c-fs-h4 font-extrabold">{sectionData.title}</h2>
        </header>
      )}
      <CarouselSection tiles={tiles} />
    </section>
  );
};
